<template>
	<q-tr :key="logId" :props="props">
		<q-td key="name" :props="props">
			<router-link :to="detailLink" v-if="!emitLog">{{ logNo }}</router-link>
			<a @click="$emit('click', log)" v-else>{{ logNo }}</a>
		</q-td>
		<q-td key="species" :props="props">{{ speciesName }}</q-td>
		<q-td key="logArea" :props="props">{{ logArea | number(userLocale) }}</q-td>
    <q-td key="resultAreaNotRemeasured" :props="props">{{ resultAreaNotRemeasured | number(userLocale) }}</q-td>
    <q-td key="inLogPercentage" :props="props">{{ (resultAreaNotRemeasured / logArea) * 100 | number(userLocale, 0, 0) }}%</q-td>
    <q-td key="measuredArea" :props="props">{{ resultAreaMeasuredBack | number(userLocale) }}</q-td>
    <q-td key="measuredAreaPercentage" :props="props">{{ (resultAreaMeasuredBack / resultAreaNotRemeasured) * 100 | number(userLocale, 0, 0) }}%</q-td>
		<q-td key="maxLength" :props="props">{{ maxLength | number(userLocale) }}</q-td>
		<q-td key="quality" :props="props">{{ customerQualityName }}</q-td>
		<q-td key="structure" :props="props">{{ structure }}</q-td>
		<q-td key="grade" :props="props">{{ grade | encodeGrade }}</q-td>
		<q-td key="palletNo" :props="props">{{ palletNo }}</q-td>
		<q-td key="place" :props="props">{{ place }}</q-td>
		<q-td key="characteristic" :props="props">{{ characteristic }}</q-td>
		<q-td key="thickness" :props="props">{{ thicknessMm | number(userLocale) }}</q-td>
		<q-td key="internalQualityName" :props="props">{{ internalQualityName }}</q-td>
		<q-td key="logInfo" :props="props">{{ logInfo }}</q-td>
		<q-td key="palletInfo" :props="props">{{ palletInfo }}</q-td>
		<q-td key="actions" :props="props">
			<q-btn @click="showMeasurementListDialog(log)"
				   icon="img:\typo3conf\ext\ig_warehouse\Resources\Public\Icons\tally-sheet.png"
				   dense
			/>
			<q-btn text-color="primary"
				   v-if="user"
				   @click="showWatchlistDialog(log)"
				   :icon="watchIcon"
				   dense
			/>
		</q-td>
	</q-tr>
</template>

<script>
	import LogPropertiesResolver from "@/mixins/LogPropertiesResolver";
	import NumberFormattingFilters from "@/mixins/NumberFormattingFilters";
	import WatchlistDialogOpener from "@/mixins/WatchlistDialogOpener";
	import MeasurementListDialogOpener from "@/mixins/MeasurementListDialogOpener";
	import {mapGetters} from "vuex";
	import GradeFilter from "@/mixins/GradeFilter";
  import WatchlistLogUtility from "@/mixins/WatchlistLogUtility";

	export default {
		name: "VeneerLogTableRow",
		mixins: [LogPropertiesResolver, NumberFormattingFilters, MeasurementListDialogOpener, WatchlistDialogOpener, GradeFilter, WatchlistLogUtility],
		props: ['props', 'emitLog'],
		computed: {
			...mapGetters(['user']),
			log() {
				return this.props.row;
			},
			detailLink() {
				return {
					name: 'detail',
					params: {
						identifier: this.logId,
						propLog: this.log
					}
				};
			}
		}
	}
</script>

<style lang="scss" scoped>
	td {
		max-width: 200px;
		white-space: normal !important;
	}
</style>